import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import {useHistory, useParams, withRouter} from "react-router-dom";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../../components/Header";
import Card from "../../../components/Card/Card";

const LeagueSelection = (props) => {
   const history = useHistory();
   const {t} = useTranslation();
   let {leagueEditionId} = useParams();

   return <div className={"LeagueSelection"}>
      <Header headerBarTitle={t("other_leagues_page.header")} showBackButton/>

      <Container className={"desktop"}>
         <Row>
            <Col className={"pb-3"} xs={12} sm={12}>
               <p>{t("other_leagues_page.select_league")}</p>
            </Col>
         </Row>

         <Row>
            {history.location.state?.leagues?.map(league => {
               return <Card
                  key={league.id}
                  text={league.name}
                  onClick={() => history.push(`/other-leagues/${leagueEditionId}/leagues/${league.id}/league-divisions`)}
               />
            })}
         </Row>
      </Container>
   </div>
}

export default withRouter(LeagueSelection);
